import { isFetchNetworkError } from "./ignored-sentry-errors"

const RETRY_DELAYS_MS = [500, 1500]

// A dropped connection to the storage host is usually back a moment later, so
// an upload gets a few tries before the visitor sees it fail.
export async function putWithRetry(
	url: string,
	init: RequestInit,
	delaysMs: readonly number[] = RETRY_DELAYS_MS,
): Promise<Response> {
	for (let attempt = 0; ; attempt++) {
		try {
			return await fetch(url, init)
		} catch (error) {
			const delay = delaysMs[attempt]
			if (delay === undefined || !isFetchNetworkError(error)) throw error
			await new Promise((resolve) => setTimeout(resolve, delay))
		}
	}
}
